import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "GamePawn.svg",
  "use": "GamePawn.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"GamePawn.svg\"><path d=\"M14,51a3.4142,3.4142,0,0,0-1,2.4142V55a1,1,0,0,0,1,1H50a1,1,0,0,0,1-1V53.4142A3.4141,3.4141,0,0,0,50,51c-2.4819-2.4819-13.3185-8.4777-14.001-25.28a1.0356,1.0356,0,0,1,.522-.9213A9.1451,9.1451,0,0,0,41,17a9,9,0,0,0-18,0,9.1451,9.1451,0,0,0,4.479,7.799,1.035,1.035,0,0,1,.522.9213C27.3184,42.5223,16.4818,48.5181,14,51Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol